import SvgIcon from "@mui/material/SvgIcon";

export default props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M8.63136 2.87152C8.48422 2.72375 8.28279 2.64075 8.07422 2.64075C7.86565 2.64075 7.66422 2.72375 7.51708 2.87152C7.36993 3.01928 7.28564 3.21969 7.28564 3.42866C7.28564 3.63763 7.36993 3.83803 7.51708 3.9858L15.5314 12.0001L7.51708 20.0144C7.37279 20.1637 7.29136 20.3635 7.29136 20.5715C7.29136 20.7795 7.37279 20.9794 7.51708 21.1287C7.66565 21.2735 7.86565 21.3545 8.07422 21.3545C8.28279 21.3545 8.48279 21.2735 8.63136 21.1287L17.7599 12.0001L8.63136 2.87152Z" fill="black"/>
  </SvgIcon>
);
